<template>
  <div id="main">
    <div class="video-container">
      <video class="video" ref="myVideo" @click="playVideo"
             src="//download.wrightin.com/website/product-t20.mp4"
             muted autoplay loop
             :poster="require('@/assets/img/product/t20/video_cover.png')" @contextmenu.prevent
             playsinline preload="auto" x5-video-player-type="h5" webkit-playsinline="true" x5-playsinline="true"
             @pause="playState(false)" @play="playState(true)">
      </video>
      <img v-if="!isVideoPlaying" class="playBtn" @click.stop="playVideo"
           :src='require("@/assets/img/product/t20/play_circle.png")' />
      <div class="copyright">广告审查批准文号:苏械广审(视)第260322-05152号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准20242090347<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用  禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司</div>
    </div>
    <div class="main">
      <p class="title">澜渟 T20 series</p>
      <p class="sub-title">治疗盆底症状＋阴道松弛</p>
      <img v-lazy="require('@/assets/img/product/t20/main-top.png')" class="top">
      <img v-lazy="require('@/assets/img/product/t20/main-bottom.png')" class="bottom">
      <div class="img-copyright" style="bottom: 0.6rem;right: 0.6rem;line-height: 0.8rem;">广告审查批准文号:苏械广审(文)第260411-06435号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准20242090347<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用  禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司</div>
    </div>
    <div class="banner">
      <p class="title">双重修复 紧致系统</p>
      <div id="bannerSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(bannerItem, bannerIndex) in bannerList" :key="bannerIndex">
            <div class="img-container">
              <img :src="bannerItem.path" alt="" />
              <div style="right: 2rem;line-height: 0.8rem;bottom: 0.6rem;" class="img-copyright" v-html="bannerItem.words"></div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <div class="pattern">
      <p class="title">创新训练模式</p>
      <div class="img-copyright" style="top: 7rem;bottom: unset;color: #ccc;line-height: 0.8rem;">广告审查批准文号:苏械广审(文)第260322-05089号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准20242090347<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用  禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司</div>
      <div id="videoSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(videoItem, videoIndex) in videoList" :key="videoIndex">
            <div class="video-container-item">
              <video :src="videoItem.path"
                     :poster="videoItem.path + '?x-oss-process=video/snapshot,t_0,f_jpg,m_fast'"
                     muted autoplay loop @contextmenu.prevent
                     playsinline preload="auto" x5-video-player-type="h5" webkit-playsinline="true"
                     x5-playsinline="true">
              </video>
            </div>
            <p class="title">{{ videoItem.title }}</p>
            <p class="desc">{{ videoItem.desc }}</p>
          </div>
        </div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
      <div class="video-container-pattern">
        <video src="//download.wrightin.com/website/product-t20-4.mp4"
               class="video" ref="myVideoPattern" @click="playVideoPattern"
               poster="//download.wrightin.com/website/product-t20-4.mp4?x-oss-process=video/snapshot,t_0,f_jpg,m_fast"
               muted autoplay loop @contextmenu.prevent
               playsinline preload="auto" x5-video-player-type="h5" webkit-playsinline="true"
               x5-playsinline="true" @pause="playStatePattern(false)" @play="playStatePattern(true)"></video>
        <img v-if="!isVideoPlayingPattern" class="playBtn" @click.stop="playVideoPattern"
             :src='require("@/assets/img/product/t20/play_circle.png")' />
        <div class="img-copyright" style="right: 2.2rem;bottom: 4.2rem;line-height: 0.8rem;">广告审查批准文号:苏械广审(视)第260322-05152号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准20242090347<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用  禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司</div>
      </div>
    </div>
    <div class="feature">
      <video class="video"
             src="//download.wrightin.com/website/product-t20-5.mp4"
             poster="//download.wrightin.com/website/product-t20-5.mp4?x-oss-process=video/snapshot,t_0,f_jpg,m_fast"
             muted autoplay loop
             @contextmenu.prevent
             playsinline preload="auto" x5-video-player-type="h5" webkit-playsinline="true" x5-playsinline="true">
      </video>
      <div class="video-cover"></div>
      <p class="title">无线体验升级 随享无拘无束</p>
      <p class="desc"></p>
      <div id="designSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(designItem, designIndex) in designList" :key="designIndex">
            <div class="img-container">
              <img :src="designItem.path" alt="" />
            </div>
            <p class="title">{{ designItem.title }}</p>
            <p class="desc">{{ designItem.desc }}</p>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <div class="img-copyright" style="color: #ccc; bottom: 0.2rem;">广告审查批准文号:苏械广审(文)第260322-05089号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准20242090347<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用  禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司</div>
    </div>
    <div class="research">
      <img v-lazy="require('@/assets/img/product/t20/zheng.png')" class="bg" />
      <p class="title">国际权威验证 专研盆底紧致</p>
      <p class="sub-title">《电刺激生物反馈在产后盆底功能康复中的临床效果评价》</p>
      <img v-lazy="require('@/assets/img/product/t20/research.png')" class="img">
      <div class="img-copyright" style="bottom: 4.6rem;">广告审查批准文号:苏械广审(文)第260322-05112号<br/>盆底康复治疗仪  医疗器械注册号:苏械注准20242090347<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用  禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司</div>
    </div>
    <div class="zhuanli">
      <p class="title">医疗器械认证及专利</p>
      <p class="sub-title"></p>
      <div class="list">
        <div class="item">
          <img v-lazy="require('@/assets/img/product/t20/zhuanli-1.png')" class="img" />
          <p class="title">盆底康复治疗仪</p>
          <p class="desc">二类医疗器械</p>
        </div>
        <div class="item">
          <img v-lazy="require('@/assets/img/product/t20/zhuanli-2.png')" class="img" />
          <p class="title">发明专利</p>
          <p class="desc">ZL 2023 1 1543573.4</p>
        </div>
        <div class="item">
          <img v-lazy="require('@/assets/img/product/t20/zhuanli-3.png')" class="img" />
          <p class="title">发明专利</p>
          <p class="desc">ZL 2023 1 0913296.5</p>
        </div>
        <div class="item">
          <img v-lazy="require('@/assets/img/product/t20/zhuanli-4.png')" class="img" />
          <p class="title">发明专利</p>
          <p class="desc">ZL 2023 1 1802368.5</p>
        </div>
        <div class="item">
          <img v-lazy="require('@/assets/img/product/t20/zhuanli-5.png')" class="img" />
          <p class="title">外观设计专利</p>
          <p class="desc">ZL202330448897.4</p>
        </div>
        <div class="item">
          <img v-lazy="require('@/assets/img/product/t20/zhuanli-6.png')" class="img" />
          <p class="title">外观设计专利</p>
          <p class="desc">ZL 2023 3 0481048.9</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.css";

export default {
  data() {
    return {
      showCopyright: true,
      showCopyrightTimer: null,
      rem: document.documentElement.style.fontSize.replace("px", "") * 1,
      isVideoPlaying: false,
      isVideoPlayingPattern: false,
      bannerSwiper: null,
      bannerList: [
        {
          path: require("@/assets/img/product/t20/system-1.png"),
          title: "盆底系统",
          desc: "唤活盆底 改善松弛",
          words: "广告审查批准文号:苏械广审(文)第260322-05089号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准20242090347<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用  禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司"
        },
        {
          path: require("@/assets/img/product/t20/system-2.png"),
          title: "私密系统",
          desc: "增强收缩 紧致阴道",
          words: "广告审查批准文号:苏械广审(文)第260322-05148号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准20242090347<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用  禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司"
        }
      ],
      videoSwiper: null,
      videoList: [
        {
          path: "//download.wrightin.com/website/product-t20-1.mp4",
          title: "多维评估，还原大设备报告",
          desc: "6分17秒 Glazer评估 国际黄金标准"
        },
        {
          path: "//download.wrightin.com/website/product-t20-2.mp4",
          title: "无线腹肌监测",
          desc: "提升训练有效性"
        },
        {
          path: "//download.wrightin.com/website/product-t20-3.mp4",
          title: "双重护航",
          desc: "建立个人专属训练模式"
        }
      ],
      designSwiper: null,
      designList: [
        {
          path: require("@/assets/img/product/t20/design-1.png"),
          title: "全新无线一体化设计",
          desc: "一键开启 摆脱有线束缚"
        },
        {
          path: require("@/assets/img/product/t20/design-2.png"),
          title: "内置除菌消毒",
          desc: "UVC灯珠 杀菌消毒"
        },
        {
          path: require("@/assets/img/product/t20/design-3.png"),
          title: "充电收纳一体",
          desc: "保护机身 长效护航"
        },
        {
          path: require("@/assets/img/product/t20/design-4.png"),
          title: "无线温热",
          desc: "加热功能 入体更舒适"
        },
        {
          path: require("@/assets/img/product/t20/design-5.png"),
          title: "1000V 耐压技术",
          desc: "科技实力 享居家修复体验"
        },
        {
          path: require("@/assets/img/product/t20/design-6.png"),
          title: "温柔振感提醒",
          desc: "训练异常实时感知 确保治疗连续性"
        }
      ]
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.showCopyrightTimer = setTimeout(() => {
      this.showCopyright = false;
      clearTimeout(this.showCopyrightTimer);
    }, 5000);
    setInterval(() => {
      this.pageScroll();
    }, 1000);
    this.bannerSwiper = new Swiper("#bannerSwiper", {
      loop: true, // 循环模式
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      }
    });
    this.videoSwiper = new Swiper("#videoSwiper", {
      loop: true, // 循环模式
      width: document.querySelector("#videoSwiper .video-container-item").clientWidth,
      spaceBetween: this.rem * 0.8,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      autoplay: {
        delay: 4100,
        disableOnInteraction: false
      }
    });
    this.designSwiper = new Swiper("#designSwiper", {
      loop: true, // 循环模式
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      }
    });
  },
  methods: {
    pageScroll() {
      // 判断 video是不是被 header sh
      const videoDom = document.querySelector(".video-container");
      const headerDom = document.querySelector("#top");
      if (videoDom && headerDom && this.$refs.myVideo) {
        // videoDom 在 屏幕中间
        if (videoDom.getBoundingClientRect().top + videoDom.getBoundingClientRect().height / 2 > headerDom.getBoundingClientRect().height &&
          window.innerHeight - videoDom.getBoundingClientRect().top > videoDom.getBoundingClientRect().height / 2) {
        } else {
          this.$refs.myVideo.pause();
          this.isVideoPlaying = false;
        }
      }
      const videoDomPattern = document.querySelector(".video-container-pattern");
      if (videoDomPattern && headerDom && this.$refs.myVideoPattern) {
        // videoDom 在 屏幕中间
        if (videoDomPattern.getBoundingClientRect().top + videoDomPattern.getBoundingClientRect().height / 2 > headerDom.getBoundingClientRect().height &&
          window.innerHeight - videoDomPattern.getBoundingClientRect().top > videoDomPattern.getBoundingClientRect().height / 2) {
        } else {
          this.$refs.myVideoPattern.pause();
          this.isVideoPlayingPattern = false;
        }
      }
    },
    playState(isPlay) {
      this.isVideoPlaying = isPlay;
      this.showCopyright = true;
      if (isPlay) {
        this.$refs.myVideo.setAttribute("controls", "true");
        this.showCopyrightTimer = setTimeout(() => {
          this.showCopyright = false;
          clearTimeout(this.showCopyrightTimer);
        }, 5000);
      } else {
        this.$refs.myVideo.removeAttribute("controls");
      }
    },
    playVideo() {
      this.$refs.myVideo.muted = false;
      this.$refs.myVideo.play();
    },
    playStatePattern(isPlay) {
      this.isVideoPlayingPattern = isPlay;
      if (isPlay) {
        this.$refs.myVideoPattern.setAttribute("controls", "true");
      } else {
        this.$refs.myVideoPattern.removeAttribute("controls");
      }
    },
    playVideoPattern() {
      this.$refs.myVideoPattern.muted = false;
      this.$refs.myVideoPattern.play();
    }
  }
};
</script>

<style lang="scss" scoped>
#main {
  background-color: #fff;
}

.video-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  > .video {
    width: 100%;
    object-fit: cover;
  }

  > .playBtn {
    position: absolute;
    width: 4.4rem;
  }

  >.copyright {
      position: absolute;
      bottom: 1.2rem;
      left: 0;
      width: 100%;
      padding: 0 2%;
      font-weight: 400;
      font-size: 0.8rem;
      color: rgba(255, 255, 255, 0.6);
      line-height: 1.2rem;
      pointer-events: none;
  }
}

.main {
  width: 100%;
  height: 66.7rem;
  background: linear-gradient(135deg, #DEE1F7 0%, #AEB4F2 100%);
  position: relative;

  > .title {
    position: absolute;
    top: 4rem;
    width: 100%;
    text-align: center;
    font-weight: 500;
    font-size: 1.8rem;
    color: #000000;
    line-height: 2.5rem;
  }

  > .sub-title {
    position: absolute;
    top: 6.9rem;
    width: 100%;
    text-align: center;
    font-weight: 500;
    font-size: 1.4rem;
    color: #000000;
    line-height: 2rem;
  }

  > .top {
    position: absolute;
    top: 12.4rem;
    left: 50%;
    width: 29.3rem;
    transform: translateX(-50%);
  }

  > .bottom {
    position: absolute;
    bottom: 2rem;
    left: 50%;
    width: 34.3rem;
    transform: translateX(-50%);
  }
}

.banner {
  width: 100%;
  background: #fff;
  position: relative;
  overflow: hidden;

  > .title {
    padding: 4rem 0;
    text-align: center;
    width: 100%;
    font-weight: 500;
    font-size: 1.8rem;
    color: #000000;
    line-height: 2.5rem;
  }

  > #bannerSwiper {
    width: 100%;
    height: 45.8rem;
    position: relative;
    margin: 0 auto;
    overflow: hidden;

    .swiper-slide {
      position: relative;

      > .img-container {
        width: 100%;
        height: 100%;
        padding: 0 1.6rem;
        overflow: hidden;
        position: absolute;

        > img {
          width: 100%;
        }
      }

      > .title {
        position: absolute;
        top: 2rem;
        width: 100%;
        font-weight: 500;
        font-size: 1.4rem;
        color: #000000;
        line-height: 2rem;
        text-align: center;
      }

      > .desc {
        position: absolute;
        top: 4.4rem;
        width: 100%;
        font-size: 1.2rem;
        color: #999999;
        line-height: 1.7rem;
        text-align: center;
      }
    }

    .swiper-pagination {
      bottom: 4rem;
    }

    /deep/ .swiper-pagination-bullet {
      background: transparent;     /* 改成透明 = 空心 */
      border: 0.1rem solid #fff;    /* 白色边框 */
      opacity: 1;
      margin: 0 0.6rem;
    }

    /deep/ .swiper-pagination-bullet-active {
      background: #fff;             /* 选中 = 白色实心 */
      border: 0.1rem solid transparent;
    }
  }
}

.pattern {
  width: 100%;
  background: #fff;
  position: relative;
  overflow: hidden;

  > .title {
    padding: 4rem 0;
    text-align: center;
    width: 100%;
    font-weight: 500;
    font-size: 1.8rem;
    color: #000000;
    line-height: 2.5rem;
  }

  > #videoSwiper {
    width: 34.3rem;
    height: 19.2rem;
    position: relative;
    margin-left: 1.6rem;

    .swiper-slide {
      position: relative;

      > .video-container-item {
        width: 34.3rem;
        height: 19.2rem;
        overflow: hidden;
        position: absolute;
        border-radius: 2rem;

        > video {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }
      }

      > .title {
        position: absolute;
        bottom: 3.2rem;
        width: 100%;
        font-weight: 500;
        font-size: 1.4rem;
        color: #fff;
        line-height: 2rem;
        text-align: center;
      }

      > .desc {
        position: absolute;
        bottom: 1.1rem;
        width: 100%;
        font-size: 1.2rem;
        color: #fff;
        line-height: 1.7rem;
        text-align: center;
      }
    }

    /deep/ .swiper-button-prev,
    /deep/ .swiper-button-next {
      color: #fff;

      &:after {
        font-size: 2rem;
        font-weight: 500;
      }
    }
  }

  .video-container-pattern {
    padding: 1.2rem 1.6rem;
    margin-bottom: 2.8rem;
    width: 100%;
    height: 42.4rem;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    > .video {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 2rem;
    }

    > .playBtn {
      position: absolute;
      width: 4.4rem;
    }
  }
}

.feature {
  width: 100%;
  background: #fff;
  position: relative;
  overflow: hidden;

  > .video {
    width: 100%;
    object-fit: cover;
  }

  > .video-cover {
    width: 100%;
    height: 5.1rem;
    background: linear-gradient(180deg, rgba(250, 251, 254, 0) 0%, #FFFFFF 90%, #FFFFFF 99%);
    transform: translateY(-100%);
    position: absolute;
  }

  > .title {
    margin-top: 2.4rem;
    text-align: center;
    width: 100%;
    font-weight: 500;
    font-size: 1.8rem;
    color: #000000;
    line-height: 2.5rem;
  }

  > .desc {
    margin-top: 0.4rem;
    text-align: center;
    width: 100%;
    font-weight: 500;
    font-size: 1.4rem;
    color: #000;
    line-height: 2rem;
  }

  > #designSwiper {
    width: 100%;
    height: 35.2rem;
    position: relative;
    margin: 4rem auto 5rem;
    overflow: hidden;

    .swiper-slide {
      position: relative;
      padding: 0 1.6rem;

      > .img-container {
        width: 34.4rem;
        height: 32.2rem;
        overflow: hidden;
        position: absolute;
        background: #F5F5F7;
        border-radius: 2rem;

        > img {
          width: 100%;
          height: 25.67rem;
        }
      }

      > .title {
        position: absolute;
        bottom: 6.3rem;
        width: 34.4rem;
        font-weight: 500;
        font-size: 1.4rem;
        color: #000000;
        line-height: 2rem;
        text-align: center;
      }

      > .desc {
        position: absolute;
        bottom: 4.2rem;
        width: 34.4rem;
        font-size: 1.2rem;
        color: #666;
        line-height: 1.7rem;
        text-align: center;
      }
    }

    .swiper-pagination {
      bottom: 1rem;
    }

    /deep/ .swiper-pagination-bullet {
      background: transparent;     /* 改成透明 = 空心 */
      border: 0.1rem solid #fff;    /* 白色边框 */
      opacity: 1;
      margin: 0 0.6rem;
    }

    /deep/ .swiper-pagination-bullet-active {
      background: #fff;             /* 选中 = 白色实心 */
      border: 0.1rem solid transparent;
    }
  }
}

.research {
  width: 100%;
  height: 54.5rem;
  background: #EBECF2;
  position: relative;

  > .bg {
    width: 100%;
    position: absolute;
    bottom: 0;
    z-index: 1;
  }

  > .title {
    position: absolute;
    top: 4rem;
    width: 100%;
    font-weight: 500;
    font-size: 1.8rem;
    color: #000000;
    line-height: 2.5rem;
    text-align: center;
    z-index: 2;
  }

  > .sub-title {
    position: absolute;
    top: 7.6rem;
    width: 100%;
    font-weight: 500;
    font-size: 1.4rem;
    color: #000;
    line-height: 2rem;
    text-align: center;
    padding: 0 3.4rem;
    z-index: 2;
  }

  > .img {
    position: absolute;
    width: 13.7rem;
    top: 14.6rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
  }
}

.zhuanli {
  position: relative;
  width: 100%;
  height: 58.3rem;
  background: #FAFBFE;

  > .title {
    position: absolute;
    top: 4rem;
    width: 100%;
    font-weight: 500;
    font-size: 1.8rem;
    color: #000000;
    line-height: 2.5rem;
    text-align: center;
  }

  > .sub-title {
    position: absolute;
    top: 6.9rem;
    width: 100%;
    font-weight: 500;
    font-size: 1.4rem;
    color: #000;
    line-height: 2rem;
    text-align: center;
  }

  >.list {
    position: absolute;
    top: 12.9rem;
    padding: 0 0.7rem 4rem 1.6rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    row-gap: 2.4rem;

    >.item {
      width: 11.62rem;
      >.img {
        width: 11.62rem;
        height: 14.72rem;
      }

      >.title {
        font-weight: 500;
        font-size: 1.3rem;
        color: #000000;
        line-height: 1.8rem;
        text-align: center;
        white-space: nowrap;
        padding-right: 0.9rem;
        margin-top: 0.9rem;
      }

      >.desc {
        font-size: 1.1rem;
        color: #999;
        line-height: 1.5rem;
        text-align: center;
        white-space: nowrap;
        padding-right: 0.9rem;
        margin-top: 0.6rem;
      }
    }
  }
}
</style>
